import ReactToPdf from "react-to-pdf";
import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
//import Cookies from "universal-cookie"
import logo from "./images/loading.gif";
//import ModalError from "./ModalError";
import config from "../config";
import Cookies from "universal-cookie";
//import Mymodal from "./modal";
//const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
const cookies=new Cookies();
export default class PaySlip extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            myitems: [],
            isLoaded: false,
            ErrMsg:<img src={logo} alt="Error"/>,
            months: ["","January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "Novermber","December"]
        }
        this.currencyFormat = this.currencyFormat.bind(this);
    }
   /* _exportPdf = () => {
    
            // do something with el.innerHTML
        html2canvas(document.querySelector("#DReport")).then(canvas => {        
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF("p", "mm", "a4");
 

        pdf.addImage(imgData, 'PNG', -50, 5); //, 600,300);
       pdf.save(cookies.get("LoginID")+".pdf"); 
   });

}*/

    currencyFormat(num) {
        let cnum=parseInt(num,0);
        if(cnum > 0)
//            return '###,###,###.#'
            return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return null
     }
    componentDidMount(){
        if(typeof this.props.location.data !== "undefined")
        {   
            document.body.style.cursor="wait";
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/payslip/',
                data: this.props.location.data,
                headers: {'Content-Type': 'multipart/form-data'}
                })
            .then((response)=>{

                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                ErrMsg:"",
                myitems: response.data
                });
            })
            .catch((response)=> {
//                document.body.style.cursor="default";
                document.body.style.cursor="default";          
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});



//                this.setState({ErrMsg:<ModalError/>});
            })     
        }
        else
        {   
//            return <Redirect to="/paylist" />
            this.props.history.push({pathname: '/paylist'});

           // this.setState({ErrMsg:<ModalError/>});
        }    

    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;
    
        if(!isLoaded) 
        {
            return (
                
                <div className="container1">            
                    <div className="center">
                          {this.state.ErrMsg}
                    </div>
                </div>
            )
        } 
        else 
        {
            return(
            items.map((result ,i) => {
            let fileName=result.emp_id+".pdf";
            return (
                <div className="container1">
                 <div width="100%"  >
                <br></br>
                 <div className="inner-profile"  >

                    <table align="center" id="DReport" name="DReport" width="650px"  ref={ref}>
                    <tr width= "650px" align="center">
                        <div   width="700px"  >
{/*}                            <h3>{config.gvr.ErrMsgs.Comp_Name}</h3>*/}
                            <h3>{result.compname}</h3>
                            <h4>Payslip</h4>
                            <table id="tablepayslip" >
                                <div align="center" >
                                    <table  width="650px" id="table44" cellspacing="0" cellpadding="0" bordercolor="#C0C0C0" height="100"  key={i}>
                                        <tr height="18" >
                                            <td className="tdheading">Code:</td>
                                            <td className="tdpayslip">
                                                {result.emp_id} 
                                            </td>
                                            <td className="tdblank"></td>
                                            <td className="tdheading">Name:</td>
                                            <td className="tdpayslip">
                                                {result.name}
                                            </td>
                                        </tr>
                                        <tr height="18">
                                            <td className="tdheading">Salary Month:</td>
                                            <td className="tdpayslip">
                                                {this.state.months[result.month]}, {result.YEAR}                                                                        
                                            </td>
                                            <td className="tdblank"></td>
                                            <td className="tdheading">Designation:</td>
                                            <td className="tdpayslip">    
                                                {result.desig}
                                            </td>
                                        </tr>
                                        <tr height="18">
                                            <td className="tdheading">Days worked:</td>
                                            <td className="tdpayslip">
                                                {result.SALARY_DAYS}
                                            </td>
                                            <td className="tdblank"></td>
                                            <td className="tdheading">Location:</td>
                                            <td className="tdpayslip">
                                                {result.locname}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <table border="0" width="650px" id="table450" cellspacing="0" cellpadding="0" height="174" >
                                    <tr >
                                        <th className="thheading">Description</th>
                                        <th className="thheading2">Allownaces</th>
                                        <th className="thheading">Description</th>
                                        <th className="thheading2">Deductions</th>
                                    </tr>
                                    <tr >
                                        <td className="tddesc"  >Basic</td>
                                        <td className="tdam"  >
                                            {this.currencyFormat(result.basic)} 
                                        </td>
                                        <td className="tddesc" >Income Tax</td>
                                        <td  className="tdam">
                                            {this.currencyFormat(result.income_tax)} 
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >House Rent</td>
                                        <td  className="tdam">
                                            {this.currencyFormat(result.h_rent)} 
                                        </td>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.eobi_emp)?"EOBI":""} 
                                        </td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.eobi_emp)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >Medical</td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.medical_all)}
                                        </td>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.saleofegg)?"Sale of eggs":""}
                                        </td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.saleofegg)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.u_all)?"Utility":""}
                                        </td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.u_all)}
                                        </td>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.electricity)?"Electricity":""}      
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.electricity)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.s_all)?"Special":""}      
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.s_all)}
                                        </td>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.others)?"Other":""}
                                        </td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.others)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.b_all)?"Bonus":""}
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.b_all)}
                                        </td>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.advance)?"Advance":""}
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.advance)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.o_all)?"Other":""}
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.o_all)}
                                        </td>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.loan)?"Loan":""}
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.loan)}
                                        </td>
                                    </tr>
                                    <tr height="30px">
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.arrear)?"Arrears":""}
                                        </td>
                                        <td className="tdam">
                                            {this.currencyFormat(result.arrear)}
                                        </td>
                                        <td className="tddesc">
                                            {!!this.currencyFormat(result.mess)?"Messing":""}
                                        </td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.mess)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="tddesc" >
                                            {!!this.currencyFormat(result.o_time)?"Over Time":""}
                                        </td>
                                        <td className="tdam" >
                                            {this.currencyFormat(result.o_time)}
                                        </td>
                                        <td className="tddesc" >
                                            &nbsp;</td>
                                        <td className="tdam" >
                                            &nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td className="tddescb" >Gross Amount:</td>
                                        <td className="tdamb" >
                                            {this.currencyFormat(result.gross)}
                                        </td>
                                        <td className="tddescb" >Total Deductions:</td>
                                        <td className="tdamb" >
                                            {this.currencyFormat(result.deductions)}
                                        </td>
                                    </tr>
                                    <tr >
                                        <td className="tddescb" >Net Salary:</td>
                                        <td className="tdamb" >
                                            {this.currencyFormat(result.net)}
                                        </td>
                                        <td className="tddescb" ></td>
                                        <td className="tdamb" >  </td>
                                    </tr>
                                     {/*<div className={!!this.currencyFormat(result.bonus+result.encash)?"divblock":"divnone"}>*/}
                                        <tr >
                                            <td colspan="4" margin="4px"  >
                                                <b>Other Income:</b>
                                            </td>
                                                                                        
                                        </tr>
                                        <tr> {/*className={!!this.currencyFormat(result.bonus)?"divblock":"divnone"}>*/}
                                                <td  className="tddescother" >Bonus:
                                                    {/*{!!this.currencyFormat(result.bonus)?"Bonus:":""}</td>*/}
                                                </td>
                                                <td className="tdamother">
                                                {!!this.currencyFormat(result.bonus)?this.currencyFormat(result.bonus):"-"}
                                                </td>
                                                <td colspan="2"></td>
                                        </tr>
                                        <tr >
                                                <td className="tddescother">Leave encashment:</td>
                                                <td className="tdamother">
                                                {!!this.currencyFormat(result.encash)?this.currencyFormat(result.encash):"-"}
                                                </td>
                                                <td colspan="2"></td>
                                        </tr>
                                </table>	                                
                            </table> 

                            <div className={!!this.currencyFormat(result.bonus)?"divbottomnone":"divbottomblock"}></div>

                            <div className="divend">
                                Credited to {result.head2}, {result.head3}. Bank Account No <b>{result.bankaccount}</b>
                            </div>
                            <div className="divend">
                                <b>Note:</b>This is a computer generated pay slip therefore does not require any signature.
                            </div>

                        </div>
                    </tr>
                </table>
                <br></br>
                <div align="center" width="400px">
                    <ReactToPdf targetRef={ref} filename={fileName} x={15} y={10} >
                        {({toPdf  }) => (
                        <button onClick={toPdf} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                        )}
                    </ReactToPdf>
                </div>

                </div>
                </div>
                <br></br><br></br>
            </div>
            )
        }))          
}
            
}}